import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageDropdown from './LanguageDropdown';

const Nav = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);
  const burgerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
        document.body.classList.remove('no-scroll');
      }
    };

    const handleClickOutside = (event) => {
      if (
        isOpen &&
        navRef.current &&
        !navRef.current.contains(event.target) &&
        !burgerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        document.body.classList.remove('no-scroll');
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
      document.body.classList.remove('no-scroll');
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <>
      <div className="nav-container">
        <button
          ref={burgerRef}
          className={`burger-menu ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav ${isOpen ? 'nav-open' : ''}`} ref={navRef}>
          {/* Desktop Layout */}
          <div className="nav-desktop">
            <a href="#about" onClick={handleNavClick}>
              {t('sections.about')}
            </a>
            <a href="#our-mission" onClick={handleNavClick}>
              {t('sections.ourMission')}
            </a>
            <a href="#contact" onClick={handleNavClick}>
              {t('sections.contact')}
            </a>
            <LanguageDropdown isMobile={false} />
          </div>

          {/* Mobile Layout */}
          <div className="nav-mobile">
            <div className="nav-links">
              <a href="#about" onClick={handleNavClick}>
                {t('sections.about')}
              </a>
              <a href="#our-mission" onClick={handleNavClick}>
                {t('sections.ourMission')}
              </a>
              <a href="#contact" onClick={handleNavClick}>
                {t('sections.contact')}
              </a>
            </div>
            <div className="nav-divider"></div>
            <LanguageDropdown isMobile={true} />
          </div>
        </nav>
      </div>
    </>
  );
};

export default Nav;
